import React from 'react';
import styled, { css } from 'styled-components';

import PoweredBy from 'components/layout/PoweredBy';
import Certificate from 'components/widgets/Certificate/Certificate';

interface IProps {
  className?: string;
}

const PciFooter = ({ className }: IProps) => {
  return (
    <Wrapper className={className} data-testid="footer">
      <Certificate />
      <PoweredBy />
    </Wrapper>
  );
};

export default PciFooter;

const Wrapper = styled.div`
  width: 100%;
  display: flex;
  align-items: ${({ theme }) => (theme.view.isMobile ? 'flex-end' : 'baseline')};
  justify-content: ${({ theme }) => (theme.view.isMobile ? 'space-between' : 'center')};
  ${({ theme }) => theme.view.isMobile && 'flex-direction: row-reverse'};

  ${({ theme }) =>
    !theme.view.isMobile &&
    css`
      > div:not(:last-child) {
        margin-right: 5rem;
      }
    `};
`;
